import { endOfDay, format, startOfDay } from "date-fns";

/**
 * Helpers de bornes de période — ticket #47.
 *
 * Les filtres de date sont exprimés en jours pleins côté utilisateur, alors que
 * les RPC comparent `date >= p_start_date AND date <= p_end_date` sur un
 * timestamptz. Sans normalisation, une borne de fin posée à minuit exclut toute
 * la journée sélectionnée (plage 24→25 qui ne remonte que le 24, ou plage d'un
 * seul jour qui ne remonte rien).
 */

/** Début de la journée locale (00:00:00.000). */
export const toRangeStart = (date: Date | null | undefined): Date | undefined =>
  date ? startOfDay(date) : undefined;

/** Fin de la journée locale (23:59:59.999), borne haute incluse. */
export const toRangeEnd = (date: Date | null | undefined): Date | undefined =>
  date ? endOfDay(date) : undefined;

/**
 * Parse une valeur `yyyy-MM-dd` d'un `<input type="date">` dans le fuseau local.
 * `new Date("2026-04-26")` serait interprété en UTC et décalerait la journée.
 */
export const parseInputDate = (value: string | null | undefined): Date | null => {
  if (!value) return null;
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
};

/**
 * Formate une date pour un `<input type="date">` dans le fuseau local.
 * `toISOString().split("T")[0]` décalerait la journée d'un cran selon l'heure.
 */
export const toInputDate = (date: Date | null | undefined): string =>
  date ? format(date, "yyyy-MM-dd") : "";
